import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTelegram } from "../hooks/useTelegram";
import "swiper/css";
import "swiper/css/navigation";
import "./GameBannerSlider.scss";

const GameBannerSlider = ({ banners = [], onClick }) => {
  const { triggerHapticFeedback } = useTelegram();
  const [imageIndex, setImageIndex] = useState(0);
  const filePath = process.env.REACT_APP_FILE_PATH;

  const handleBannerClick = (banner) => {
    triggerHapticFeedback('impact', 'medium');
    if (typeof onClick === 'function') {
      onClick(banner);
    }
  };

  // If there are no banners, optionally show a placeholder or return null
  if (!banners.length) {
    return <div className="gameBannerSlider-empty">Нет баннеров</div>;
  }

  return (
    <Swiper
      slidesPerView="auto"
      spaceBetween={20}
      onSlideChange={(swiper) => setImageIndex(swiper.activeIndex)}
      loop={false}
      navigation={false}
      className="gameBannerSlider"
    >
      {banners.map((banner, index) => (
        <SwiperSlide key={banner.gameId || index} className="gameBannerSlide">
          <img
            src={`${filePath}/Games/${banner.fileName}`}
            alt={banner.title || banner.name}
            className="slideImage"
            onClick={() => handleBannerClick(banner)}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default GameBannerSlider;
